// Limites e allowlist de anexos de comentario. Replicados client-side para UX;
// o backend e a fonte de verdade (valida extensao + MIME real + tamanho).
export const MAX_ATTACHMENTS_PER_COMMENT = 5
export const MAX_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024 // 10MB

// Extensoes permitidas (imagens + documentos). Espelha a allowlist do backend.
export const ALLOWED_IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp']
export const ALLOWED_DOC_EXTENSIONS = ['pdf', 'docx', 'xlsx', 'csv', 'pptx', 'txt']
export const ALLOWED_EXTENSIONS = ALLOWED_IMAGE_EXTENSIONS.concat(ALLOWED_DOC_EXTENSIONS)

// `accept` do input file — derivado da allowlist (pontos prefixados).
export const ACCEPT_ATTR = ALLOWED_EXTENSIONS.map(function (ext) {
  return '.' + ext
}).join(',')

// As FUNCOES (getExtension, isImageAttachment, getAttachmentIcon) vivem em
// `@modules/tarefas/utils/attachments` — este arquivo guarda so constantes.
//
// O mapa de icones por tipo de arquivo NAO vive mais aqui: reutilizamos o
// AAWZ_DRIVE_FILE_ICONS_MAP do modulo aawz-drive (PR review — Herik). Ver
// `utils/attachments.js::getAttachmentIcon`.
